import { Divider, Stack, SxProps, TextField } from "@mui/material"
import { NumberField } from "../../components/Fields/NumberField"
import { Label } from "../../components/Typography/Typography"
import { useMissions } from "../../hooks/useMissions"
import { MissionType } from "../../store/types/MissionsTypes"
import { ShippingInfoCardList } from "./ShippingInfoCardList"
import { SortieCardList } from "./SortieCardList"

const storageDriveTextFieldSxProp: SxProps = { maxWidth: 480, mb: 2 }

export const FlightData = () => {
    const { missions, isNoAcquisition, handleMissionDataChange } = useMissions()
    const { selectedMission, isVendorFlow } = missions

    const handleFlightNumChange = <T extends keyof MissionType>(value: MissionType[T], field: T) => {
        if (field === "flight_num") {
            const hasNonDigits = !/^[0-9]*$/.test(String(value))
            if (value != null && typeof value === "number" && (hasNonDigits || value >= 100)) {
                return
            }
        }
        handleMissionDataChange({ [field]: value })
    }

    return (
        <Stack spacing={2}>
            <Label>Flight Data</Label>
            <NumberField
                sx={{ width: 80 }}
                label="Flight No."
                required
                min={1}
                max={99}
                value={selectedMission.flight_num}
                onChange={(value) => handleFlightNumChange(value ?? null, "flight_num")}
                step={1}
            />

            {/* Sorties */}
            <SortieCardList />

            {/* mission_shipping_info */}
            {!isNoAcquisition && (
                <Stack>
                    <Divider sx={{ mb: 4 }} />

                    <Label>Storage Drives</Label>

                    <TextField
                        label={"Plane Drive Name"}
                        variant="outlined"
                        fullWidth={true}
                        sx={storageDriveTextFieldSxProp}
                        value={selectedMission?.plane_drive_name ?? ""}
                        onChange={(e) => handleMissionDataChange({ plane_drive_name: e.target.value })}
                        helperText={!isVendorFlow && "Required (hard drive used during acquisition)"}
                        error={!isVendorFlow && !selectedMission?.plane_drive_name}
                    />
                    <TextField
                        label={"Main Backup Drive"}
                        variant="outlined"
                        fullWidth={true}
                        sx={storageDriveTextFieldSxProp}
                        value={selectedMission?.backup_drive_name ?? ""}
                        onChange={(e) => handleMissionDataChange({ backup_drive_name: e.target.value })}
                        error={!isVendorFlow && !selectedMission?.backup_drive_name}
                        helperText={!isVendorFlow && "Required (field backup hard drive)"}
                    />
                    <ShippingInfoCardList />
                </Stack>
            )}
        </Stack>
    )
}
